import { AdminLabOrderList, LabOrder } from "pwapi";

import {
  ExternalLabsState,
  ExternalLabStainsState,
  LabStainsState,
  StainsState,
} from "shared/reducers/frontLoaderReducers";
import { appendSendoutIfNeeded } from "shared/utils/labUtils";
import { getStainByLabStainId } from "shared/utils/stainUtils";

import { useAppSelector } from "store/hooks";

import { getOrderStatus } from "../components/admin/editCasePanel/Orders.helpers";

type OrderLike = LabOrder | AdminLabOrderList;

interface LabStainMetaDeps {
  stains: StainsState;
  labStains: LabStainsState;
  externalLabs: ExternalLabsState;
  externalLabStains: ExternalLabStainsState;
}

export const getLabStainMeta = (
  labStainId: number | undefined,
  { stains, labStains, externalLabs, externalLabStains }: LabStainMetaDeps
) => {
  const stain = labStainId
    ? getStainByLabStainId(labStainId, stains, labStains)
    : undefined;
  const labStain = labStainId ? labStains[labStainId] : undefined;
  const externalLabId =
    externalLabStains[labStain?.external_lab_stain_id || 0]?.external_lab_id;
  const externalLab = externalLabId ? externalLabs[externalLabId] : undefined;
  const externalLabName = externalLab?.name
    ? appendSendoutIfNeeded(externalLab.name)
    : undefined;

  return {
    stain,
    labStain,
    isExternalLabStain: !!externalLabId,
    externalLabName,
  };
};

export const useLabOrderMeta = (order?: OrderLike) => {
  const stains = useAppSelector(({ stains }) => stains);
  const labStains = useAppSelector(({ labStains }) => labStains);
  const externalLabs = useAppSelector(({ externalLabs }) => externalLabs);
  const externalLabStains = useAppSelector(
    ({ externalLabStains }) => externalLabStains
  );

  return {
    ...getLabStainMeta(order?.lab_stain_id, {
      stains,
      labStains,
      externalLabs,
      externalLabStains,
    }),
    orderStatus: order ? getOrderStatus(order) : undefined,
  };
};
